var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "M40.483 20.93C40.483 9.892 31.54.95 20.503.95S.523 9.891.523 20.93c0 9.99 7.25 18.288 16.838 19.739V26.73h-5.076V20.93h5.076v-4.35c0-4.996 2.98-7.816 7.492-7.816 2.256 0 4.512.403 4.512.403v4.915h-2.498c-2.497 0-3.303 1.53-3.303 3.142v3.706h5.56l-.887 5.8h-4.673V40.67c9.587-1.45 16.919-9.749 16.919-19.74"
  })));
};
export default SvgFacebook;